export enum ContactsTypeModel {
  CONTACT_RECORDS = "contactRecords",
  PHONE_BOOK = "phoneBook",
  MEMORY_GROUPS = "memoryGroups",
}
